import React from 'react';

import { isCustomerVerificationSession } from '../../utils/verificationSession';
import type { VerificationAccessFailure } from '../../utils/verificationCredentials';
import CustomerLinkExpired from './CustomerLinkExpired';
import DifferentAccount from './DifferentAccount';
import LoginToContinue from './LoginToContinue';
import Unavailable from './Unavailable';

interface Props {
  access?: VerificationAccessFailure | null;
  verificationId?: string;
  isLoggedIn: boolean;
}

// `access` is only set for failures from the BFF's verification auth or a
// customer session; everything else keeps the page's default error handling.
export const verificationAccessScreen = ({
  access,
  verificationId,
  isLoggedIn,
}: Props): JSX.Element | null => {
  if (!access) return null;
  if (access.status === 410) return <Unavailable />;
  if (isCustomerVerificationSession(verificationId)) {
    return <CustomerLinkExpired />;
  }
  if (access.status === 401) return <LoginToContinue />;
  // A portal token login is not marked logged in until reports load.
  return isLoggedIn || access.credentialed ? <DifferentAccount /> : null;
};
